import { ref, readonly, computed } from 'vue'
import { defineStore } from 'pinia'

export interface iInternalUser {
  id: number
  fullname: string
  email: string
  phone: string
  gender: userGender
  alamat: string
  npwp: string | null
  role: userRole
  last_login: string
  created_at: string
  updated_at: string | null
  deleted_at: string | null
  reset_token: string | null
  reset_token_expired_at: string | null
}
export enum userGender {
  MALE = 'male',
  female = 'female'
}
export enum userRole {
  OWNER = 'owner',
  writter = 'writter',
  AUDITOR = 'auditor',
  ADMIN = 'admin'
}

export const internalUserStore = defineStore('internalUser', () => {
  const internalUserList = ref<iInternalUser[]>([])

  const getInternalUserList = readonly(internalUserList)

  function setInternalUserList(list: iInternalUser[]) {
    internalUserList.value = list
  }
  function setDefault() {
    internalUserList.value = []
  }

  return { getInternalUserList, setInternalUserList, setDefault }
})
